export default __webpack_public_path__ + "upload/location.ee2dcf89.svg";